import { FontMap, WidgetFontName } from './client';

/**
 * Inject a Google Fonts <link> stylesheet into <head> for the given font.
 * Deduplicates by element id so each font is loaded only once.
 */
export function ensureGoogleFont(key: WidgetFontName): void {
  const font = FontMap[key];

  if (!font) {
    return;
  }

  const id = `gf-${key}`;

  if (document.getElementById(id)) {
    return;
  }

  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = font.url;

  document.head.appendChild(link);
}
